import React, { useEffect, useState } from "react";
import { Form, Button, Card, Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../../config";

export default function LocalTaxPage() {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const storedCompany = localStorage.getItem("selectedCompany");
    return storedCompany ? JSON.parse(storedCompany).id : "";
  });
  const [tax, setTax] = useState(0);
  const [loading, setLoading] = useState(false);

  // Fetch companies and validate selectedCompany
  useEffect(() => {
    async function fetchCompanies() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE_URL}/companies`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const companyData = res.data || [];
        setCompanies(companyData);

        // Validate stored selectedCompany
        const storedCompany = localStorage.getItem("selectedCompany");
        if (storedCompany) {
          const parsedCompany = JSON.parse(storedCompany);
          const isValidCompany = companyData.some((c) => c.id === parsedCompany.id);
          if (!isValidCompany) {
            localStorage.removeItem("selectedCompany");
            setSelectedCompany("");
          } else {
            setSelectedCompany(parsedCompany.id);
            fetchTax(parsedCompany.id);
          }
        }
      } catch (err) {
        console.error("fetchCompanies", err);
        Swal.fire("Error", "Failed to load companies", "error");
        setSelectedCompany("");
      }
    }
    fetchCompanies();
  }, []);

  const fetchTax = async (companyId) => {
    if (!companyId) {
      setTax(0);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/companies/${companyId}/local-tax`);
      setTax(res.data.tax_percent || 0);
    } catch (err) {
      console.error("fetchTax", err);
      Swal.fire("Error", "Failed to load tax info", "error");
      setTax(0);
    } finally {
      setLoading(false);
    }
  };

  const saveTax = async () => {
    if (!selectedCompany) {
      Swal.fire("Validation", "Select a company first", "warning");
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/companies/${selectedCompany}/local-tax`, { tax_percent: tax });
      Swal.fire("Success", "Tax updated successfully", "success");
    } catch (err) {
      console.error("saveTax", err);
      Swal.fire("Error", "Failed to update tax", "error");
    }
  };

  const handleCompanyChange = (e) => {
    const companyId = e.target.value;
    setSelectedCompany(companyId);
    const selectedCompanyObj = companies.find((c) => c.id === companyId);
    localStorage.setItem("selectedCompany", JSON.stringify(selectedCompanyObj || {}));
    fetchTax(companyId);
  };

  return (
    <div className="container mt-4">
      <Card>
        <Card.Body>
          <Card.Title><i className="bi bi-percent me-2"></i>Manage Local Tax</Card.Title>

          {/* Company Select */}
          <Form.Group className="mb-3">
            <Form.Label>Select Company</Form.Label>
            <Form.Select value={selectedCompany} onChange={handleCompanyChange}>
              <option value="">-- Select Company --</option>
              {companies.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          {loading ? <Spinner animation="border" /> : (
            selectedCompany && (
              <Form>
                <Form.Group>
                  <Form.Label>Default Tax (%)</Form.Label>
                  <Form.Control
                    type="number"
                    value={tax}
                    onChange={(e) => setTax(e.target.value)}
                  />
                </Form.Group>
                <Button className="mt-3" onClick={saveTax}>Save</Button>
              </Form>
            )
          )}
        </Card.Body>
      </Card>
    </div>
  );
}